import React from 'react'
import PropTypes from 'prop-types'

import { DashboardModule, Form } from '@domain-group/suit-theme'

const ProposalSettings = (props) => {
  const { serviceProductForm } = props

  const {
    entityState: {
      options: { proposal },
    },
    handlers,
  } = serviceProductForm

  const { templatable, type } = proposal

  return (
    <DashboardModule title="Proposal Settings">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="Type">
            <select
              data-value-type="text"
              name="options.proposal.type"
              value={type}
              {...handlers}
            >
              <option value="standard_document">Standard Document</option>
              <option value="premium_document">Premium Document</option>
              <option value="rental_document">Rental Document</option>
              <option value="standard_digital">Digital Proposal</option>
            </select>
          </Form.Field>

          <Form.Field label="Templatable" marginTop={['large', 0]}>
            <select
              data-value-type="boolean"
              name="options.proposal.templatable"
              value={templatable}
              {...handlers}
            >
              <option value="false">No</option>
              <option value="true">Yes</option>
            </select>
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

ProposalSettings.propTypes = {
  serviceProductForm: PropTypes.object,
}

export default ProposalSettings
